import React from 'react';
import styled from '@emotion/styled';
import { useInView } from 'react-intersection-observer';


const AnimatedSection = ({id,children}) =>{
  const { ref, inView } = useInView({
    rootMargin: "100px 0px 30px 0px"
  });
 
  return (
    <SectionWrapper ref={ref} className={inView ? 'active' : ''} id={id}>
      {children}
    </SectionWrapper>
  );

}

export default AnimatedSection;

const SectionWrapper = styled.div`
position:relative;
margin: 0 auto;
width:100%;
z-index:5;
  > *{
    opacity:0;
    transform:translateY(30px);
    transition:all .5s;
    position:relative;
  }
  

  &.active > *{
    opacity:1;
    transform:none;
  }
`
